import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.668.5 7.711.913l.62 2.936 1.957-.413L9.668.5ZM7.766 10.595a3 3 0 0 1 5.329-1.892l1.122-1.726a5 5 0 1 0-5.357 8.242l1.123-1.728a3.001 3.001 0 0 1-2.217-2.896ZM4.67 23.5l8.343-12.835 3.252 5.003 1.248-2.184L23.236 23.5H4.67ZM1.83 5.87l1.092-1.675 2.513 1.638-1.091 1.675L1.83 5.871Zm15.221-3.212-1.676-1.092-1.637 2.514 1.676 1.092 1.637-2.514ZM6.096 15.81l1.676 1.092-1.637 2.514-1.676-1.091 1.637-2.514ZM.764 11.578l.413 1.957 2.935-.62L3.7 10.96l-2.935.62Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconFinanceFarEast24 = createIcon(IconComponent);